import React from 'react';
import styled from 'styled-components';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SArrowDown = styled.main<{}>(
  ({ theme }) => `
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 120px;
        justify-content: flex-end;
        background: ${theme.colors.primaryBackground};
        padding-bottom: 40px;
    `
);

const STitle = styled.div<{}>(
  ({ theme }) => `
        font-weight: ${theme.font.weight.lighter};
        font-size: font-size: ${theme.font.size.smallMedium2};
        line-height: 15px;
        text-align: center;
        color: ${theme.colors.white};
        margin: 4px 0px;
  `
);

const SArrowIcon = styled.div<{}>(
  ({ theme }) => `
        border: solid ${theme.colors.white};
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 4px;
        margin: 5px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        cursor: pointer;
    `
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IArrowDownProps {
  onArrowClick: () => void;
  title: string;
}

export default function ArrowDown({ onArrowClick, title }: IArrowDownProps) {
  return (
    <SArrowDown>
      <STitle>{title}</STitle>
      <SArrowIcon onClick={onArrowClick}></SArrowIcon>
    </SArrowDown>
  );
}
